<template>
  <div>
    <div class="row">
      <div class="col">
        <h2>Review Request Image</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-5">
        <div>
          <input type="file" accept="image/*" @change="handleImageUpload" />
        </div>
        <div>
          <input v-model="rotation" type="range" min="-45" max="45" @input="drawCanvas" />
        </div>
        <div>
          <input v-model="text" type="text" placeholder="Enter text" @input="drawCanvas" />
        </div>
      </div>
      <div class="col-sm-7 text-center">
        <canvas ref="canvas" width="600" height="600"></canvas>
      </div>
    </div>

  </div>
</template>

<script>
import Vue from "vue";
export default {
  components:{
  },
  data(){
    return {
      image: null,
      rotation: 0,
      text: "Hi [firstname]",
      dragging: false,
      canvas:null,
      overlay: {
        x: 20,   // Start near top-left
        y: 20,   // Start near top-left
        width: 200,  // Adjust width dynamically
        height: 50,  // Adjust height dynamically
      },
      dragOffsetX: 0,
      dragOffsetY: 0,
      overlayCanvas:null,
      overlayCtx:null,
      user:{
        business:{
          business_name:null,
          business_phone:null,
          social_settings:{
            facebook_images:[],
            instagram_images:[],
            gbp_images:[]
          }
        }
      },
    }
  },
  computed:{

  },
  watch:{

  },
  mounted() {
    this.user = Vue.util.extend({}, this.$store.getters['auth/user']);
    this.canvas = this.$refs.canvas;
    // Create an offscreen canvas for overlay
    this.overlayCanvas = document.createElement("canvas");
    this.overlayCanvas.width = this.canvas.width;
    this.overlayCanvas.height = this.canvas.height;
    this.overlayCtx = this.overlayCanvas.getContext("2d");

    this.canvas.addEventListener("mousedown", this.startDrag);
    this.canvas.addEventListener("mousemove", this.onDrag);
    this.canvas.addEventListener("mouseup", this.stopDrag);
    this.drawCanvas();
  },
  methods: {
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.image = new Image();
          this.image.src = e.target.result;
          this.image.onload = this.drawCanvas;
        };
        reader.readAsDataURL(file);
      }
    },
    drawCanvas() {
      const canvas = this.$refs.canvas;
      const ctx = canvas.getContext("2d");

      // Clear main canvas
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      if (this.image) {
        ctx.drawImage(this.image, 0, 0, canvas.width, canvas.height);
      }

      // Clear overlay canvas and redraw text
      this.overlayCtx.clearRect(0, 0, this.overlayCanvas.width, this.overlayCanvas.height);
      this.overlayCtx.save();
      this.overlayCtx.translate(this.overlay.x, this.overlay.y);
      this.overlayCtx.rotate((this.rotation * Math.PI) / 180);
      this.overlayCtx.fillStyle = "rgba(255, 255, 255, 0.8)";
      this.overlayCtx.fillRect(0, 0, this.overlay.width, this.overlay.height);

      // Dynamically calculate font size
      let fontSize = 20; // Default font size
      this.overlayCtx.font = `${fontSize}px Arial`;
      let textWidth = this.overlayCtx.measureText(this.text).width;

      // Adjust font size until text fits within overlay width
      while (textWidth > this.overlay.width - 20 && fontSize > 5) {
        fontSize--;
        this.overlayCtx.font = `${fontSize}px Arial`;
        textWidth = this.overlayCtx.measureText(this.text).width;
      }

      this.overlayCtx.fillStyle = "black";

      // Calculate the center x-coordinate of the white box
      const centerX = this.overlay.width / 2;

      this.overlayCtx.textAlign = 'center'; // Set text alignment to center
      this.overlayCtx.fillText(this.text, centerX, this.overlay.height / 2 + fontSize / 2 - 2); // Center text horizontally and vertically

      this.overlayCtx.restore();

      // Merge overlay onto main canvas
      ctx.drawImage(this.overlayCanvas, 0, 0);
    },

    startDrag(e) {
      const rect = this.$refs.canvas.getBoundingClientRect();
      const mouseX = e.clientX - rect.left - window.pageXOffset;
      const mouseY = e.clientY - rect.top - window.pageYOffset;

      const overlayCenterX = this.overlay.x + this.overlay.width / 2;
      const overlayCenterY = this.overlay.y + this.overlay.height / 2;

      const deltaX = mouseX - overlayCenterX;
      const deltaY = mouseY - overlayCenterY;

      const angle = -this.rotation * Math.PI / 180;

      const rotatedDeltaX = deltaX * Math.cos(angle) - deltaY * Math.sin(angle);
      const rotatedDeltaY = deltaX * Math.sin(angle) + deltaY * Math.cos(angle);

      const localMouseX = rotatedDeltaX + this.overlay.width / 2;
      const localMouseY = rotatedDeltaY + this.overlay.height / 2;

      // Increase the drag area by a small factor (e.g., 1.2)
      const dragAreaFactor = 3;
      const extendedWidth = this.overlay.width * dragAreaFactor;
      const extendedHeight = this.overlay.height * dragAreaFactor;

      // Offset the top drag area to push it down
      const topOffset = 65; // Adjust this value to control the offset

      if (localMouseX >= -((extendedWidth - this.overlay.width) / 2) &&
          localMouseX <= extendedWidth - ((extendedWidth - this.overlay.width) / 2) &&
          localMouseY >= -((extendedHeight - this.overlay.height) / 2) + topOffset && // Apply topOffset here
          localMouseY <= extendedHeight - ((extendedHeight - this.overlay.height) / 2)) {
        this.dragging = true;
        this.dragOffsetX = mouseX - this.overlay.x;
        this.dragOffsetY = mouseY - this.overlay.y;
      }
    },

    onDrag(e) {
      if (!this.dragging) return;

      const rect = this.$refs.canvas.getBoundingClientRect();
      this.overlay.x = e.clientX - rect.left - this.dragOffsetX;
      this.overlay.y = e.clientY - rect.top - this.dragOffsetY;

      this.drawCanvas();
    },

    stopDrag() {
      this.dragging = false;
    }
  }
}
</script>
<style lang="scss" scoped>
canvas {
  width: 800px;
  height: 800px;
  border: 1px solid #ddd;
  cursor: grab;
}
</style>
